module.exports = __webpack_public_path__ + "static/media/lockdown.ad8a5d87.svg";